<template>
  <transition name="modal">
    <div
      v-if="isVisible"
      class="fullscreen-modal"
      @close="closeModal"
    >
      <div class="fullscreen-modal__header">
        <slot name="header" />
        <a
          v-if="showCloseBtn"
          class="fullscreen-modal__close"
          @click.prevent="closeModal"
        >
          <font-awesome-icon
            icon="times"
            size="2x"
          />
        </a>
      </div>

      <slot />
    </div>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  name: 'FullscreenModal',
  components: {
    FontAwesomeIcon
  },
  props: {
    id: {
      type: String,
      required: true
    },
    showCloseBtn: {
      type: Boolean,
      default: () => true
    }
  },
  computed: {
    ...mapGetters([
      'fullscreenModalVisible'
    ]),
    isVisible () {
      return this.fullscreenModalVisible(this.id)
    }
  },
  watch: {
    isVisible: {
      immediate: true,
      handler () {
        if (this.isVisible) {
          this.$emit('open')
          document.querySelector('html').classList.add('noscroll')
        } else {
          this.$emit('close')
          document.querySelector('html').classList.remove('noscroll')
        }
      }
    }
  },
  methods: {
    ...mapActions({
      closeModal: 'closeFullscreenModal'
    })
  }
}
</script>

<style lang="sass">
@import "~styles/imports"

=noscroll
  overflow: hidden
  position: absolute
  touch-action: none
  width: 100vw

html.noscroll
  +noscroll
  body
    +noscroll

.modal-enter-active,
.modal-leave-active
  transition: opacity .5s

.modal-enter,
.modal-leave-to
  opacity: 0

.fullscreen-modal
  +z-index('fullscreen-modal')
  background: $color-white
  position: absolute
  top: 0
  left: 0
  right: 0
  bottom: 0

  &--open
    display: block

  &__close
    +font-size(15, 15)
    color: #000
    cursor: pointer
    position: absolute
    top: 25px
    right: 25px

  &__header
    z-index: 50
    background: $color-white
    border-bottom: 1px solid #eeeeee
    display: flex
    justify-content: center
    flex-direction: center
    height: 4.82353rem
    padding: 0rem 0.88235rem
    position: fixed
    left: 0
    right: 0
    top: 0

  &__content
    background: $color-white
    border-radius: $border-radius
    width: 100%

    position: fixed
    left: 0
    right: 0
    top: rem-calc(80)
    bottom: rem-calc(100)
    overflow-y: scroll

    +respond-min($md)
      padding-left: rem-calc(40)
      padding-right: rem-calc(40)

    +respond-max($md)
      padding-left: rem-calc(20)
      padding-right: rem-calc(20)

  &__footer
    background-color: #f0f3f5
    height: auto
    padding: 30px 0
    position: fixed
    bottom: 0
    left: 0
    right: 0



</style>



// WEBPACK FOOTER //
// src/components/app/FullscreenModal.vue